import React, { useEffect, useState } from "react";
import { Bar, Doughnut, Line } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import { postApiCall } from "../../../utils/api";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ContentReportChart from "./component/contentreport";
import {
  Box,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
} from "@mui/material";
import MaterialTable from "material-table";
import tableIcons from "../../component/MaterialIcon";
import { ThemeProvider, createTheme } from "@mui/material";
import ModuleCompletionChart from "./component/modulecompletionchart";
Chart.register(...registerables);

const SchoolAnalytics = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  // const { id } = useParams();
  // const queryParams = new URLSearchParams(location.search);
  // const schoolName = queryParams.get("name");
  // const { id, name } = location.state || {};
  // const [params] = useSearchParams();
  // const id = params.get("id");
  // const name = params.get("name");
  const [params] = useSearchParams();

  const id = params.get("id");
  const name = params.get("name");

  const [data, setData] = useState(null);
  const [chooseClass, setChooseClass] = useState("");
  const [moduleCompletionCountByGrade, setModuleCompletionCountByGrade] =
    useState([]);
  const [tableData, setTableData] = useState([]);
  const [basicInfo, setBasicInfo] = useState({});
  const classes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  useEffect(() => {
    const fetchSchoolAnalytics = async () => {
      try {
        const res = await postApiCall("school-analytics-by-id", {
          school_id: id,
        });


        if (res.success) {
          setData(res.data);
          setBasicInfo(res.data.schoolBasicInfo);
        }
      } catch (error) {
        console.error("Error fetching school analytics:", error);
      }
    };

    fetchSchoolAnalytics();
  }, [id]);

  if (!data) return <div>Loading...</div>;

  // 1. Student Status Doughnut Chart
  const studentStats = data.studentStats || {};
  const studentLabels = [
    "Invited",
    "Registered",
    "Active",
    "Registered for Olympiad",
  ];
  const studentData = [
    parseInt(studentStats.invited || 0),
    parseInt(studentStats.registered || 0),
    parseInt(studentStats.activeStudents || 0),
    parseInt(studentStats.registered_for_olympiad || 0),
  ];
  const studentChart = {
    labels: studentLabels,
    datasets: [
      {
        data: studentData,
        backgroundColor: ["#4caf50", "#ff9800", "#f44336", "#2196f3"],
      },
    ],
  };

  // 2. Progress Milestones Bar Chart
  const milestones = data.progressMilestones || {};
  const milestoneLabels = Object.keys(milestones);
  const milestoneValues = milestoneLabels.map((key) => milestones[key]);
  const milestoneChart = {
    labels: milestoneLabels.map((m) => `${m}%`),
    datasets: [
      {
        label: "Student Count",
        data: milestoneValues,
        backgroundColor: "#2196f3",
      },
    ],
  };

  // 3. Average Progress Line Chart
  const avgProgressChart = {
    labels: ["Average Progress"],
    datasets: [
      {
        label: "%",
        data: [parseFloat(data.averageProgress || 0)],
        borderColor: "#3f51b5",
        fill: false,
        tension: 0.4,
      },
    ],
  };

  // 4. Module Breakdown Horizontal Bar
  const moduleBreakdown = data.moduleBreakdown || [];
  const moduleLabels = moduleBreakdown.map((m) => m.module_name);
  const moduleCounts = moduleBreakdown.map((m) => parseInt(m.completions || 0));
  const moduleChart = {
    labels: moduleLabels,
    datasets: [
      {
        label: "Completions",
        data: moduleCounts,
        backgroundColor: "#009688",
      },
    ],
  };

  // 5. Top Performers Chart
  const topPerformers = data.topPerformers || [];
  const performerLabels = topPerformers.map((p) => p.name);
  const performerValues = topPerformers.map((p) =>
    parseFloat(p.average_progress || 0)
  );
  const performerChart = {
    labels: performerLabels,
    datasets: [
      {
        label: "Avg. Progress",
        data: performerValues,
        backgroundColor: "#9c27b0",
      },
    ],
  };

  const handleClassSelect = async (e) => {
    setChooseClass(e.target.value);
    const res = await postApiCall("get-school-analytics-by-grade", {
      school_id: id,
      grade: e.target.value.toString(),
    });
    setModuleCompletionCountByGrade(
      res.data.moduleCompletionCountByGrade || []
    );
    setTableData(res.data.studentDataModuleWise || []);
    res.data.studentDataModuleWise.forEach((data, index) => {
      data.serial = index + 1;
    });
  };

  const handleNameClick = async (rowData) => {
    navigate("/studentanalytics", {
      state: {
        id: rowData.id,
        name: rowData.name,
      },
    });
  };

  const columns = [
    { title: "Sl. no", field: "serial", width: "10%" },
    {
      title: "Name",
      field: "name",
      render: (rowData) => {
        return (
          <div
            style={{
              color: "blue",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => handleNameClick(rowData)}
          >
            {rowData.name}
          </div>
        );
      },
    },
    {
      title: "Module",
      field: "module_name",
    },
    { title: "Progress", field: "progress" },
  ];

  return (
    <div className="content-wrapper mt-4">
      <section className="content">
        <div className="container-fluid">
          <h2 className="mb-4 pt-4">
            📊 School Analytics {name && `- ${name}`}
          </h2>
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="mb-0">Basic Information</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>School Name:</strong> {basicInfo.name || "N/A"}
                  </p>
                  <p>
                    <strong>School Type:</strong>{" "}
                    {basicInfo.school_type || "N/A"}
                  </p>
                  <p>
                    <strong>Email:</strong> {basicInfo.email || "N/A"}
                  </p>
                  <p>
                    <strong>Phone:</strong> {basicInfo.phone || "N/A"}
                  </p>
                  <p>
                    <strong>Address:</strong> {basicInfo.address || "N/A"}
                  </p>
                  <p>
                    <strong>City:</strong> {basicInfo.city || "N/A"}
                  </p>
                  <p>
                    <strong>State:</strong> {basicInfo.state || "N/A"}
                  </p>
                  <p>
                    <strong>Pincode:</strong> {basicInfo.pincode || "N/A"}
                  </p>
                  <p>
                    <strong>Created On:</strong>{" "}
                    {basicInfo.created_at
                      ? new Date(basicInfo.created_at).toLocaleString("en-GB")
                      : "N/A"}
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>Coordinator:</strong>{" "}
                    {basicInfo.coordinatorname || "N/A"}
                  </p>
                  <p>
                    <strong>Coordinator Email:</strong>{" "}
                    {basicInfo.coordinatoremail || "N/A"}
                  </p>
                  <p>
                    <strong>Coordinator Phone:</strong>{" "}
                    {basicInfo.coordinatorphone || "N/A"}
                  </p>
                  <p>
                    <strong>Start Road Safety Club?:</strong>{" "}
                    {basicInfo.start_road_safety_club || "N/A"}
                  </p>
                  <p>
                    <strong>Know About School?:</strong>{" "}
                    {basicInfo.is_know_about_school || "N/A"}
                  </p>
                  <p>
                    <strong>Total Students:</strong>{" "}
                    {basicInfo.studentcount || "0"}
                  </p>
                  <p>
                    <strong>Unique URL:</strong>{" "}
                    {basicInfo.complete_shorten_unique_url || "NA"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Row 1: Student Stats + Milestones */}
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="card p-3 h-100 position-relative">
                <h5>Student Status</h5>

                {/* Numbers in corner */}
                <div
                  style={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    fontSize: "12px",
                    textAlign: "right",
                  }}
                >
                  <div style={{ color: "#4caf50" }}>
                    Invited: {studentData[0]}
                  </div>
                  <div style={{ color: "#ff9800" }}>
                    Registered: {studentData[1]}
                  </div>
                  <div style={{ color: "#f44336" }}>
                    Active: {studentData[2]}
                  </div>
                  <div style={{ color: "#2196f3" }}>
                    Registered for Olympiad: {studentData[3]}
                  </div>
                </div>

                {studentData.reduce((a, b) => a + b, 0) === 0 ? (
                  <p>No student status data available.</p>
                ) : (
                  <div style={{ width: 300, margin: "0 auto" }}>
                    <Doughnut data={studentChart} />
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="card p-3 h-100">
                <h5>Content Completion Report</h5>
                {data.contentReport.length === 0 ? (
                  <p>No Report.</p>
                ) : (
                  <ContentReportChart contentReport={data.contentReport} />
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="card p-3 h-100">
                <h5>Select Grade</h5>
                <FormControl
                  fullWidth
                  required
                  style={{ backgroundColor: "#e2d6d6" }}
                >
                  {/* <InputLabel>Class</InputLabel> */}
                  <Select
                    name="class"
                    value={chooseClass}
                    onChange={handleClassSelect}
                    label="Class"
                    displayEmpty
                    required
                  >
                    <MenuItem value="" disabled>
                      Select Class
                    </MenuItem>
                    {classes.map((cls) => (
                      <MenuItem key={cls} value={cls}>
                        {cls}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="card p-3 h-100">
                <h5>Module-wise Completion</h5>
                {moduleCompletionCountByGrade.length === 0 ? (
                  <p>Module Completion Data Not Found</p>
                ) : (
                  <ModuleCompletionChart
                    moduleCompletionCountByGrade={moduleCompletionCountByGrade}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 mt-4">
              <div className="card card-primary">
                <ThemeProvider theme={defaultMaterialTheme}>
                  <MaterialTable
                    icons={tableIcons}
                    title="Module Progress by Student"
                    columns={columns}
                    data={tableData}
                    onRowClick={(evt, selectedRow) =>
                      setSelectedRow(selectedRow.tableData.id)
                    }
                    options={{
                      exportButton: true,
                      actionsColumnIndex: -1,
                      headerStyle: {
                        backgroundColor: "rgb(0 123 255)",
                        color: "#FFF",
                        fontSize: 18,
                      },
                      rowStyle: (rowData, index) => ({
                        backgroundColor:
                          selectedRow === rowData.tableData.id
                            ? "#d3d4d1"
                            : index % 2 !== 0
                            ? "#EEE"
                            : "#FFF",
                      }),
                    }}
                  />
                </ThemeProvider>
              </div>
            </div>
          </div>

          {/* Row 2: Average Progress + Module Breakdown */}
          {/* <div className="row">
            <div className="col-md-6 mb-4">
              <div className="card p-3 h-100">
                <h5>Average Module Progress</h5>
                {data.averageProgress == null ? (
                  <p>No average progress data available.</p>
                ) : (
                  <Line data={avgProgressChart} />
                )}
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="card p-3 h-100">
                <h5>Module-wise Completion</h5>
                {moduleLabels.length === 0 ? (
                  <p>No module breakdown data available.</p>
                ) : (
                  <Bar
                    data={moduleChart}
                    options={{
                      indexAxis: "y",
                    }}
                  />
                )}
              </div>
            </div>
          </div> */}

          {/* Row 3: Top Performers */}
          {/* <div className="row">
            <div className="col-md-12 mb-4">
              <div className="card p-3">
                <h5>Top Performing Students</h5>
                {performerLabels.length === 0 ? (
                  <p>No top performers data available.</p>
                ) : (
                  <Bar data={performerChart} />
                )}
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default SchoolAnalytics;
